import dayjs, { Dayjs } from 'dayjs';
import { FormattedDate, FormattedMessage } from 'react-intl';
import { Stack } from '@mui/material';

import { PoolDatePicker } from '../../date-picker/pool-date-picker';
import { useFilter } from '../context/filter-context';

type DateRangeFilterProps = {
    fromField: string;
    untilField: string;
};

export const DateRangeFilter = ({ fromField, untilField }: DateRangeFilterProps) => {
    const { filter, updateFilter, registerFilterMap } = useFilter();

    const handleChangeFrom = (value: Dayjs | null) => {
        filter.delete(fromField);
        if (value?.isValid()) {
            filter.set(fromField, value.startOf('day').format('YYYY-MM-DD'));
        }
        updateFilter(filter);
    };

    const handleChangeTo = (value: Dayjs | null) => {
        filter.delete(untilField);
        if (value?.isValid()) {
            filter.set(untilField, value.endOf('day').format('YYYY-MM-DD'));
        }
        updateFilter(filter);
    };

    const dateToString = (rfcString: unknown) =>
        (rfcString as string) && (
            <FormattedDate value={new Date(rfcString as string)} year="numeric" month="short" day="2-digit" />
        );

    registerFilterMap(fromField, dateToString);
    registerFilterMap(untilField, dateToString);

    const currentFrom = filter.get(fromField);
    const currentTo = filter.get(untilField);
    return (
        <Stack gap={1} direction="row">
            <PoolDatePicker
                label={<FormattedMessage id="app.filter.date.from" />}
                value={currentFrom ? dayjs(currentFrom) : null}
                onChange={handleChangeFrom}
            />
            <PoolDatePicker
                label={<FormattedMessage id="app.filter.date.until" />}
                value={currentTo ? dayjs(currentTo) : null}
                onChange={handleChangeTo}
            />
        </Stack>
    );
};
